<template>
  <loading v-if="loading" />

  <div id="wrapper" :class="noheader">
    <Banner title="看診進度" />
    <div class="content appointment" v-if="data.timestamp">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>看診進度</p>
          <span></span>
        </div>
        <a v-if="notFromLine" class="arr" @click.prevent="$router.replace(from)"
          ><div class="inner"></div
        ></a>
      </div>
      <div class="appointment_title">
        <div class="date">
          <p>{{ data.timestamp }}</p>
        </div>
        <div class="now">
          <p>目前為{{ data.secPresent.sec }}時段</p>
          <span>{{ data.secPresent.period }}</span>
        </div>
      </div>
      <div class="appointmentBox">
        <div class="box title">
          <div><span>診間資訊</span></div>
          <div style="text-align: center;"><span>目前號碼</span></div>
          <div style="text-align: center;"><span>下一號</span></div>
        </div>
        <template v-for="(i, idx) in info" :key="idx">
          <div class="box" v-if="i.status === '看診中'">
            <div>
              <span>{{ i.room }}&nbsp;{{ i.sec }}</span>
              <p>{{ i.dept }}&nbsp;{{ i.doctor }}&nbsp; {{ i.title }}</p>
            </div>
            <div>
              <div style="font-size: 1.8em; text-align: center; color:#F09E49">
                {{ i.currentNo }}
              </div>
              <div style="font-size: 0.6; text-align: center; color:#F09E49">
                <div v-if="i.currentPassed">過號</div>
              </div>
            </div>
            <div>
              <div style="font-size: 1.8em; text-align: center; color:#F09E49">
                {{ i.nextNo }}
              </div>
              <div style="font-size: 0.6; text-align: center; color:#F09E49">
                <div v-if="i.nextPassed">過號</div>
              </div>
            </div>
          </div>
          <div class="box close" v-else>
            <div>
              <span>{{ i.room }}&nbsp;{{ i.sec }}</span>
              <p>{{ i.dept }}&nbsp;{{ i.doctor }}&nbsp; {{ i.title }}</p>
            </div>
            <div class="suspension">目前暫停看診<br />手術中(生產)</div>
          </div>
        </template>
      </div>
      <p class="appointmentTxt" style="text-align: left;">
        如您初次至木生看診，請準備身分證字號方便建立病歷。<br /><br />
        兒科門診時間：<br />
        早診&nbsp;&nbsp;<span>09:00&nbsp;-&nbsp;12:00</span>。
        <br />現場掛號、預約報到<span> 11:30</span> 截止<br />
        午診&nbsp;&nbsp;<span>13:30&nbsp;-&nbsp;16:30</span>。
        <br />現場掛號、預約報到<span> 16:00</span>
        截止
        <br /><br />
        婦產科門診時間：<br />
        早診&nbsp;&nbsp;<span>09:00&nbsp;-&nbsp;12:30</span>。
        <br />現場掛號、預約報到<span> 12:30</span> 截止<br />
        午診&nbsp;&nbsp;<span>13:30&nbsp;-&nbsp;17:00</span>。
        <br />現場掛號、預約報到<span> 17:00</span> 截止<br />
        夜診&nbsp;&nbsp;<span>18:00&nbsp;-&nbsp;21:00</span>。
        <br />現場掛號、預約報到<span> 20:30</span> 截止.<br />
      </p>
    </div>
  </div>

  <modal v-if="modal.display" @close="modal.display = false">
    <template v-slot:header v-if="modal.header">{{ modal.header }}</template>
    <template v-slot:body>{{ modal.body }}</template>
  </modal>
</template>

<script>
import Banner from "../components/Banner.vue";
import api from "../api/index";

export default {
  components: {
    Banner
  },
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      loading: true,
      modal: {},
      timer: null,
      interval: 3 * 1000,
      data: { waitinfo: [], timestamp: "" },
      params: null
    };
  },
  computed: {
    notFromLine() {
      return !this.from.includes("WaitInfo");
    },
    member() {
      return this.$store.state.member;
    },
    from() {
      return this.$store.state.from;
    },
    info() {
      return this.data.progress;
    },
    timestamp() {
      return this.data.timestamp;
    },
    isMobile() {
      return this.member.platform.match(/^(line|develop)$/);
    },
    noheader() {
      return this.isMobile ? "noheader" : null;
    }
  },
  mounted() {
    this.getWaitInfo();
    this.timer = setInterval(this.getWaitInfo, this.interval);
  }, //mounted
  methods: {
    getWaitInfo() {
      api.progress
        .query({
          platform: this.member.platform,
          jwt: "3LxXA4DHS2sNwHkQt3EyCorE267mNk7MPCmf"
        })
        .then(data => {
          console.log(data);
          if (data.code === "success") {
            this.data = data;
            this.loading = false;
            this.modal.display = false;
          }
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
};
</script>
